module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!-- 单个儿童年龄选择框组件&lt; -->\n<div class="drag-down-wrap">\n    <my-select class="ac-select-children-age select" unselectable="on" data-value="0" data-track="公共_成人小孩_小孩年龄"><1岁</my-select>\n    <i class="drag-down"></i>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/common/adultChildrenSelect/templates/childrenAgeSelector.ejs
// module id = 71
// module chunks = 3 5 6 7 8 9